<script lang="ts" setup>
import type { Editor } from '@tiptap/vue-3'
import type { StyleValue } from 'vue'
import { computed } from 'vue'
import { DropdownMenuCheckboxItem, DropdownMenuShortcut } from '@/foundation/dropdown-menu'
import ActionDropdownButton from '@/notebook/components/ActionDropdownButton.vue'
import { Icon, type icons } from '@/notebook/components/icons'
import type { ButtonViewReturnComponentProps } from '@/notebook/type'
import { getShortcutKeys } from '@/notebook/utils/plateform'

export type Item = {
  title: string
  icon?: keyof typeof icons
  isActive: NonNullable<ButtonViewReturnComponentProps['isActive']>
  action?: ButtonViewReturnComponentProps['action']
  style?: StyleValue
  shortcutKeys?: string[]
  disabled?: boolean
  divider?: boolean
  default?: boolean
}
type Props = {
  editor: Editor
  disabled?: boolean
  color?: string
  maxHeight?: string | number
  icon?: any
  tooltip?: string
  items?: Item[]
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  color: undefined,
  maxHeight: undefined,
  icon: undefined,
  tooltip: '',
  items: () => [],
})

const active = computed(() => {
  const find: any = props.items.find((k: any) => k.isActive())

  if (find && !find.default) {
    return {
      ...find,
      icon: find.icon ? find.icon : props.icon,
    }
  }
  const item: Item = {
    title: props.tooltip,
    icon: props.icon,
    isActive: () => false,
  }

  return item
})
</script>

<template>
  <ActionDropdownButton :icon="icon" :tooltip="tooltip" :disabled="disabled">
    <DropdownMenuCheckboxItem
      v-for="(item, index) in props.items"
      :key="index"
      :checked="active.title === item.title"
      :disabled="item.disabled"
      class="flex gap-3 items-center"
      @click="item.action"
    >
      <Icon v-if="item.icon" :name="item.icon" />
      <span class="ml-1">{{ item.title }}</span>
      <DropdownMenuShortcut v-if="item.shortcutKeys" class="ml-auto">{{
        getShortcutKeys(item.shortcutKeys)
      }}</DropdownMenuShortcut>
    </DropdownMenuCheckboxItem>
  </ActionDropdownButton>
</template>
